import { DateRangePicker } from '@ironscales/design-system'

export default DateRangePicker

export const formatDateRange = DateRangePicker.formatDateRange
